/*@ngInject*/
module.exports = function publicServicesService($http) {

    this.getServiceDataById = function(serviceId) {
        return $http.get('services/getServiceDataById/' + serviceId);
    };

    this.getServicesBySearch = function(filter, search) {
        return $http.post('services/getServicesBySearch/', {filter, search});
    };

    this.servicesAmountForTypes = function() {
        return $http.get('services/servicesAmountForTypes/');
    };

};


/** WEBPACK FOOTER **
 ** ./app/shared/services/public-services.service.js
 **/